import { StatusCell, type StatusVariant } from '../../../../components/status/status-cell';
import type { LiveSyncState, SyncStatus } from '../types';
import { LastRefreshed } from './last-refreshed';

const liveChip: Record<
  LiveSyncState,
  { variant: StatusVariant; label: (pollMs: number) => string }
> = {
  connecting: { variant: 'muted', label: () => 'Connecting…' },
  live: { variant: 'success', label: () => 'Live' },
  saving: { variant: 'attention', label: () => 'Saving…' },
  // Quotes the hook's own poll period, so the user is told exactly how
  // stale the page can be until the socket is back.
  offline: { variant: 'danger', label: (pollMs) => `Offline · checking every ${pollMs / 1000}s` },
};

// The header's "how current is this page" indicator. Forks on the view
// model's shape, never on the rollout flag: v1 reports a poll and keeps its
// "last synced" text; v2 reports a live connection and gets a status pill.
export function SyncIndicator({ sync }: { sync: SyncStatus }) {
  if (sync.kind === 'poll') {
    return <LastRefreshed lastRefreshed={sync.lastRefreshed} paused={sync.paused} />;
  }

  const { variant, label } = liveChip[sync.state];

  return (
    <StatusCell variant={variant} tone="soft" className="justify-self-end font-mono">
      {label(sync.pollMs)}
    </StatusCell>
  );
}
